export default {
    sitesScheduleSelected: [],
}
